import { render, staticRenderFns } from "./AppointmentsTotalizer.vue?vue&type=template&id=2154dbf5&scoped=true"
import script from "./AppointmentsTotalizer.vue?vue&type=script&lang=js"
export * from "./AppointmentsTotalizer.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsTotalizer.vue?vue&type=style&index=0&id=2154dbf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154dbf5",
  null
  
)

export default component.exports